<template>
<v-layout align-center justify-center>
  <v-flex xs12 sm8 md4>
<v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
              <v-icon>person</v-icon>
                <v-toolbar-title class="ml-2">User Signup</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="user name"
                    name="user"
                    prepend-icon="person"
                    type="text"
                    v-model="user"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    v-model="password"
                  ></v-text-field>

                    <v-text-field
                    id="cnf_password"
                    label="Confirm Password"
                    name="cnf_password"
                    prepend-icon="lock"
                    type="password"
                    v-model="cnf_password"
                  />

                  <v-text-field id="phone" label="Phone Number" prepend-icon="phone" v-model="phone" />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="signup">Signup</v-btn>
              </v-card-actions>
            </v-card>
  </v-flex>
</v-layout>
 
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data: () =>({
        user: null,
        password: null,
        cnf_password: null,
        phone: null
    }),
  
    methods: {
      ...mapActions({
        create_user: 'signup/create_user' 
      }),
      signup () {
        this.create_user({ user: this.user,
                          password: this.password,
                          phone: this.phone
                      })
        //console.log(this.$store.state.login.user)
      }
    }
}
</script>

<style>

</style>
